import { useMemo } from "react";
import { useSearchParams } from "react-router";

export function useEditMode() {
  const [searchParams] = useSearchParams();

  const editModeData = useMemo(() => {
    const asgid = searchParams.get("asgid");
    const editParam = searchParams.get("edit");
    const compositionId = searchParams.get("compositionid");

    const isEditMode = editParam === "true" && !!asgid;

    return {
      isEditMode,
      assemblyGroupId: isEditMode ? asgid : null,
      compositionId: isEditMode ? compositionId : null
    };
  }, [searchParams]);

  return editModeData;
}
